import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';
import moment from 'moment';


Snappy.Component.WembleyStadiumSignUpForm = class WembleyStadiumSignUpForm extends Snappy.BaseComponent {
    static get tagName() {
        return 'fa-ws-signup-form';
    }

    constructor(element) {
        super(element);
    }

    setVars() {
        this.errorMessage = document.getElementsByClassName('fa-input-field__error-message');
        this.firstName = document.getElementsByName('FirstName');
        this.surname = document.getElementsByName('LastName');
        this.dateOfBirth = document.getElementsByName('DateOfBirth');
        this.email = document.getElementsByName('Email');
        this.emailConfirm = document.getElementsByName('EmailConfirm');
        this.phone = document.getElementsByName('Phone');
        this.otherPhone = document.getElementsByName('OtherPhone');
        this.postcode = document.getElementsByName('Postcode');
        this.address1 = document.getElementsByName('Address1');
        this.address2 = document.getElementsByName('Address2');
        this.address3 = document.getElementsByName('Address3');
        this.city = document.getElementsByName('City');
        this.county = document.getElementsByName('County');
        this.country = document.getElementsByName('Country');
        this.password = document.getElementsByName('Password');
        this.passwordConfirm = document.getElementsByName('PasswordConfirm');
        this.agreeToTsAndCs = document.querySelectorAll('[name="TermsAndConditionsAcceptance"][type=checkbox]');
        this.agreeToMarketing = document.querySelectorAll('[name="MarketingAcceptance"][type=checkbox]');
        this.formTextInputs = document.querySelectorAll('.fa-signup-form__form input[type=text]');
        this.submitBtn = document.getElementById('ws-signup-form-submit');
        this.findAddressLink = document.getElementById('ws-find-address-submit');
        this.manualAddressLink = document.getElementById('ws-manual-address-submit');
        this.addressFieldSetContainer = document.getElementById('ws-address-field-set');
        this.addressSearchResultContainer = document.getElementsByClassName('ws-address-results')[0];
    }

    addEventListeners() {
        this.submitBtn.addEventListener('click', this.validateForm.bind(this));
        this.findAddressLink.addEventListener('click', this.findAddress.bind(this));
        this.manualAddressLink.addEventListener('click', this.enterAddressManually.bind(this));

        for (var i = 0; i < this.formTextInputs.length; i++) {
            this.formTextInputs[i].addEventListener('keyup', this.removeErrors.bind(this));
        }
    }

    removeErrors(event) {
        if (event.target.classList.contains('error')) {
            event.target.classList.remove('error');
            event.target.nextSibling.nextElementSibling.style.display = 'none';
        }
    }

    validateForm(event) {
        event.preventDefault();
        let isValidDate;
        let isEmailValid;
        let isSubmissionValid = true;
        const requiredFields = {
            dateOfBirth: 'DateOfBirth',
            firstName: 'FirstName',
            surname: 'LastName',
            email: 'Email',
            phone: 'Phone',
            postcode: 'Postcode',
            addressLine1: 'Address1',
            city: 'City',
            county: 'County',
            country: 'Country',
            password: 'Password'
        }

        // add errors to all required fields
        for (var k in requiredFields) {
            var domElement = document.getElementsByName(requiredFields[k]);
            if (domElement[0].value === '') {
                isSubmissionValid = false;
                this.setDomElementOnInvalidState(domElement[0], `Please enter a ${domElement[0].previousSibling.previousElementSibling.innerHTML.toLowerCase()}`);
            }
            else {
                this.setDomElementOnValidState(domElement[0]);
            }
        }

        // check if recaptcha is valid
        isSubmissionValid = this.isRecaptchaValid();

        // scroll up to div if error exists
        if ($('.error').length) {
            $('html, body').animate({
                scrollTop: $('.error:visible:first').offset().top - 130
            }, 1000);
        }

        if (this.agreeToTsAndCs[0].checked === false) {
            isSubmissionValid = false;
            this.setDomElementOnInvalidState(this.agreeToTsAndCs[0].parentElement, 'Please agree to the terms and conditions');
        }
        else {
            this.setDomElementOnValidState(this.agreeToTsAndCs[0].parentElement);
        }

        isValidDate = moment(this.dateOfBirth[0].value, 'DD/MM/YYYY', true).isValid();
        if (isValidDate) {
            this.setDomElementOnValidState(this.dateOfBirth[0]);
        } else {
            isSubmissionValid = false;
            this.setDomElementOnInvalidState(this.dateOfBirth[0], 'Please enter a valid date');
        }

        this.setDomElementOnValidState(this.emailConfirm[0]);
        if (this.email[0].value !== '') {
            isEmailValid = this.validateEmail(this.email[0].value);
            if (isEmailValid) {
                if (this.email[0].value === this.emailConfirm[0].value) {
                    this.setDomElementOnValidState(this.email[0]);
                    this.setDomElementOnValidState(this.emailConfirm[0]);
                }
                else {
                    isSubmissionValid = false;
                    this.setDomElementOnInvalidState(this.email[0], 'Emails do not match');
                    this.setDomElementOnInvalidState(this.emailConfirm[0], 'Emails do not match');
                }
            }
            else {
                isSubmissionValid = false;
                this.setDomElementOnInvalidState(this.email[0], 'Please enter a valid email address');
            }
        }

        if (this.firstName[0].value !== '') {
            if (this.firstName[0].value.length <= 1) {
                isSubmissionValid = false;
                this.setDomElementOnInvalidState(this.firstName[0], 'Oops! Your first name should have at least two characters');
            }
        }

        if (this.surname[0].value !== '') {
            if (this.surname[0].value.length <= 1) {
                isSubmissionValid = false;
                this.setDomElementOnInvalidState(this.surname[0], 'Oops! Your last name should have at least two characters');
            }
        }

        this.setDomElementOnValidState(this.passwordConfirm[0]);
        if (this.password[0].value !== '') {
            if (this.password[0].value === this.passwordConfirm[0].value) {
                this.setDomElementOnValidState(this.password[0]);
                this.setDomElementOnValidState(this.passwordConfirm[0]);
            }
            else {
                isSubmissionValid = false;
                this.setDomElementOnInvalidState(this.password[0], 'Passwords do not match');
                this.setDomElementOnInvalidState(this.passwordConfirm[0], 'Passwords do not match');
            }
        }

        if (isSubmissionValid) {
            // call ajax service
            this.postFormData();
        }
        return isSubmissionValid;
    }

    isRecaptchaValid() {
        const recaptcha = $("#g-recaptcha-response").val();
        const recaptchaError = document.querySelectorAll('.recaptcha-error')[0];
        let isValid = true;

        if (recaptcha === "") {
            isValid = false;
            recaptchaError.innerHTML = 'Please check the recaptcha';
            recaptchaError.style.display = 'block';
        } else {
            recaptchaError.style.display = 'none';
        }

        return isValid;
    }

    enterAddressManually(event) {
        this.address1[0].value = '';
        this.address2[0].value = '';
        this.address3[0].value = '';
        this.city[0].value = '';
        this.county[0].value = '';
        this.country[0].value = '';
        this.addressSearchResultContainer.style.display = 'none';
        this.addressFieldSetContainer.style.display = 'block';
        return false;
    }

    findAddress(event) {
        event.preventDefault();

        //show loading GIF
        $('.loading-message-wrapper').removeClass('hide').addClass('show');

        var endpoint = '/accounts/postcode?postcode=' + this.postcode[0].value;
        this.addressFieldSetContainer.style.display = 'none';
        this.addressSearchResultContainer.style.display = 'none';
        $(".ws-address-results ul").html('');
        var postcodeErrorControl =
            document.getElementsByName('Postcode')[0].parentNode.getElementsByClassName(
                'fa-input-field__error-message')[0];

        if (postcodeErrorControl !== undefined && postcodeErrorControl !== null) {
            postcodeErrorControl.innerText = '';
            postcodeErrorControl.style.display = 'none';
        }

        $.ajax({
            url: endpoint,
            type: "GET",
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function (response) {
                $('.loading-message-wrapper').removeClass('show').addClass('hide');
                if (response != null) {

                    var addresses = response["Addresses"];
                    if (addresses.length > 0) {
                        $.each(addresses, function (index, value) {
                            // RDSN: Taken from IR js
                            var address = value["Address"].split("|");
                            var addressShortName = "";
                            if (address[0] !== "")
                                addressShortName = addressShortName + address[0];
                            if (address[1] !== "")
                                addressShortName = addressShortName + ", " + address[1];

                            var addressBlock = value["Address"].replace(/\'/g, "");
                            $(".ws-address-results ul").append("<li class='addressClick'><a " + " address='" + addressBlock + "'>" + addressShortName + "</a></li>");
                            $('.ws-address-results').show();
                            var addressResultLinks = document.getElementsByClassName('addressClick');
                        });
                    }
                    else {
                        if (postcodeErrorControl !== undefined && postcodeErrorControl !== null) {
                            postcodeErrorControl.innerText =
                                "Are you sure? We can't find your address. Can you try enter your address manually please?";
                            postcodeErrorControl.style.display = 'block';
                        }
                    }
                }
            },
            error: function (response) {
                $('.loading-message-wrapper').removeClass('show').addClass('hide');
            }
        });
    }

    postFormData() {
        const endpoint = document.getElementsByClassName('fa-signup-form__form')[0].getAttribute('action');

        //build json
        var jsonRequest = {
            'FirstName': this.firstName[0].value,
            'LastName': this.surname[0].value,
            'DateOfBirth': this.dateOfBirth[0].value,
            'Email': this.email[0].value,
            'EmailConfirm': this.emailConfirm[0].value,
            'Phone': this.phone[0].value,
            'OtherPhone': this.otherPhone[0].value,
            'Postcode': this.postcode[0].value,
            'Address1': this.address1[0].value,
            'Address2': this.address2[0].value,
            'Address3': this.address3[0].value,
            'City': this.city[0].value,
            'County': this.county[0].value,
            'Country': this.country[0].value,
            'Password': this.password[0].value,
            'PasswordConfirm': this.passwordConfirm[0].value,
            'TermsAndConditionsAcceptance': this.agreeToTsAndCs[0].checked,
            'MarketingAcceptance': this.agreeToMarketing[0].checked
        };

        //show loading GIF
        $('.loading-message-wrapper').removeClass('hide').addClass('show');
        document.querySelectorAll('.submission__success')[0].style.display = 'none';
        document.querySelectorAll('.submission__error')[0].style.display = 'none';

        $.ajax({
            url: endpoint,
            type: "POST",
            data: JSON.stringify(jsonRequest),
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function (response) {
                $('.loading-message-wrapper').removeClass('show').addClass('hide');

                if (response != undefined) {
                    if (response.IsValid) {
                        executeValidResponse(response);

                    } else {
                        executeInvalidResponse(response);
                    }
                }

                function executeValidResponse(apiResponse) {
                    document.querySelectorAll('.submission__success')[0].style.display = 'block';
                    $('html, body').animate({
                        scrollTop: $('.submission__success').offset().top - 130
                    }, 1000);

                    var allFormTextInputs = document.querySelectorAll('.fa-signup-form__form input[type=text]');
                    for (var i = 0; i < allFormTextInputs.length; i++) {
                        allFormTextInputs[i].value = '';
                    }

                    var allFormPasswordInputs = document.querySelectorAll('.fa-signup-form__form input[type=password]');
                    for (var x = 0; x < allFormPasswordInputs.length; x++) {
                        allFormPasswordInputs[x].value = '';
                    }

                    var allFormCheckboxInputs = document.querySelectorAll('.fa-signup-form__form input[type=checkbox]');
                    for (var y = 0; y < allFormCheckboxInputs.length; y++) {
                        allFormCheckboxInputs[y].checked = false;
                    }

                    var form = document.querySelectorAll('.fa-signup-form__form');
                    if ((form != undefined && form.length > 0)) {
                        form[0].style.display = 'none';
                    }
                }

                function executeInvalidResponse(apiResponse) {
                    document.querySelectorAll('.submission__error')[0].style.display = 'block';

                    var errorMessageSummary = document.getElementById('errorMessageSummary');
                    if (errorMessageSummary != undefined) {
                        errorMessageSummary.innerHTML = '';
                    }

                    if ((apiResponse != undefined) && (!apiResponse.IsValid)) {
                        for (var key in apiResponse.Errors) {
                            var inputDomElement = document.getElementsByName(key);
                            if (inputDomElement.length > 0) {
                                inputDomElement[0].classList.add('error');
                                inputDomElement[0].nextSibling.nextElementSibling.innerHTML = response.Errors[key];
                                inputDomElement[0].nextSibling.nextElementSibling.style.display = 'block';
                            }
                            else {
                                if (errorMessageSummary !== undefined) {
                                    errorMessageSummary.innerHTML += response.Errors[key];
                                }
                            }
                        }
                    }

                    $('html, body').animate({
                        scrollTop: $('.submission__error').offset().top - 130
                    }, 1000);
                }
            }
        });
    }

    validateEmail(email) {
        const expr = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return expr.test(email);
    };

    setDomElementOnInvalidState(domElement, errorMessage) {
        domElement.classList.add('error');
        domElement.nextSibling.nextElementSibling.innerHTML = errorMessage;
        domElement.nextSibling.nextElementSibling.style.display = 'block';
    };

    setDomElementOnValidState(domElement) {
        domElement.classList.remove('error');
        domElement.nextSibling.nextElementSibling.innerHTML = '';
        domElement.nextSibling.nextElementSibling.style.display = 'none';
    };

    render() {
        this.setVars();
        this.addEventListeners();

        $(document).delegate('.addressClick a', 'click', function () {
            var addressAsArray = $(this).attr('address').split('|');
            document.getElementsByName('Address1')[0].value = addressAsArray[0];
            document.getElementsByName('Address2')[0].value = addressAsArray[1];
            document.getElementsByName('Address3')[0].value = addressAsArray[2];
            document.getElementsByName('Postcode')[0].value = addressAsArray[3];
            document.getElementsByName('City')[0].value = addressAsArray[4];
            document.getElementsByName('County')[0].value = addressAsArray[5];
            document.getElementsByName('Country')[0].value = addressAsArray[6];
            document.getElementById('ws-address-field-set').style.display = 'block';
            document.getElementsByClassName('ws-address-results')[0].style.display = 'none';
        });

        $(document).ready(function () {
            $('#DateOfBirth').bind('keyup',
                'keydown',
                function (event) {
                    var inputLength = event.target.value.length;
                    if (event.keyCode != 8) {
                        if (inputLength === 2 || inputLength === 5) {
                            var thisVal = event.target.value;
                            thisVal += '/';
                            $(event.target).val(thisVal);
                        }
                    }
                }
            );
        });
    };
}



// WEBPACK FOOTER //
// ./components/ws-signup-form/scripts/signup-form.js